import * as React from "react";
import UnorderedList from "molecules/lists/unordered-list";

interface RadioListProps {
    items: JSX.Element[];
    markerPosition?: RadioMarkerPosition;
    style?: RadioListStyles;
    alignHorizontally?: boolean;
}

export enum RadioListStyles {
    Default = "-default",
    Button = "-button-style",
    None = "-none-style",
}

export enum RadioMarkerPosition {
    Left = "-markers-left",
    Right = "-markers-right",
}

const cssBaseClassName = "c-radio-list";

const RadioList: React.FunctionComponent<RadioListProps> = (props) => {
    const { items, markerPosition, style, alignHorizontally } = props;

    if (items.length === 0) {
        return null;
    }

    const classNames = [cssBaseClassName];
    if (style != null) {
        classNames.push(style);
    }

    classNames.push(markerPosition ?? RadioMarkerPosition.Right);

    classNames.push(
        alignHorizontally ? "-align-horizontally" : "-align-vertically"
    );

    return (
        <fieldset className={classNames.join(" ")}>
            <UnorderedList
                cssClassName={`${cssBaseClassName}__list`}
                listItems={items}
            />
        </fieldset>
    );
};

export default RadioList;
